import List, { HeadCell } from 'components/list/list';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ChileOrderRow from 'views/order-feed/features/my-supply-plan/features/ofd-1.0/components/order-list/chile-order-row';
import ChileRecommendedOrderListRow from 'views/order-feed/features/my-supply-plan/features/ofd-1.0/components/order-list/chile-recommended-order-list-row';
import { OrderListItem } from 'views/order-feed/features/my-supply-plan/features/ofd-1.0/types/order-list-item.type';
import { RecommendedOrder } from 'views/order-feed/features/my-supply-plan/features/ofd-1.0/types/recommendation.type';

type Props = {
  isLoading: boolean;
  orders: OrderListItem[];
  recommendedOrders: RecommendedOrder[];
  isNoResults: boolean;
};

const PAGE_NAME_ID = 'orderFeed.listOrderSupplyPlan';

const ChileOrderList: React.FC<Props> = ({ isLoading, orders, recommendedOrders, isNoResults }) => {
  const intl = useIntl();
  const listOptions: HeadCell[] = [
    { id: 'status', label: '', align: 'center', autoWidth: true },
    { id: 'orderNumber', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.orderList.orderNumberLabel` }) },
    { id: 'customerOrderReference', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.orderList.customerOrderReferenceLabel` }) },
    { id: '', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.orderList.changePossibleLabel` }) },
    {
      id: 'deliveryDate',
      label: intl.formatMessage({ id: 'orderFeed.ofdMySupplyPlan.orders.list.deliveryDate' }),
    },
    {
      id: 'totalOrderQty',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.orderList.totalOrderQtyLabel` }),
      align: 'right',
    },
    { id: 'actions', label: '', align: 'right', autoWidth: true },
    { id: 'expand', label: '', align: 'right', autoWidth: true },
  ];

  return (
    <List
      options={listOptions}
      isLoading={isLoading}
      noResult={{
        show: isNoResults,
        text: <FormattedMessage id={`${PAGE_NAME_ID}.orderList.noResults`} />,
      }}>
      {orders.map((order) => (
        <ChileOrderRow key={order.orderNumber} order={order} />
      ))}
      {recommendedOrders.map((recommendedOrder) => (
        <ChileRecommendedOrderListRow
          key={`${recommendedOrder.siteErpId}_${recommendedOrder.date}_${recommendedOrder.scheduleId}`}
          recommendedOrder={recommendedOrder}
          listOptions={listOptions}
        />
      ))}
    </List>
  );
};

export default ChileOrderList;
